import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "left m l" }
const _hoisted_2 = {
  class: "circle margin",
  src: _imports_0,
  ref: "logo"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", null, "sports_hockey", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Games", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", null, "more_vert", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "List", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", null, "settings", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "Verwaltung", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, "User", -1)
const _hoisted_12 = { class: "bottom s" }
const _hoisted_13 = {
  class: "circle margin",
  src: _imports_0,
  ref: "logo"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", null, "sports_hockey", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", null, "more_vert", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", null, "settings", -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "responsive" }
const _hoisted_20 = {
  class: "app-version",
  "data-cy": "app-version"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_an_loader = _resolveComponent("an-loader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_an_toasts = _resolveComponent("an-toasts")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_an_loader, { height: 3 }),
    _createElementVNode("nav", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createElementVNode("img", _hoisted_2, null, 512)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/games",
        "data-cy": "games"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      ($setup.isAdmin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "list"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ($setup.isAdmin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/admin"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, { to: "/user" }, {
        default: _withCtx(() => [
          ($setup.isLoggedIn)
            ? (_openBlock(), _createElementBlock("i", _hoisted_9, "person"))
            : _createCommentVNode("", true),
          (!$setup.isLoggedIn)
            ? (_openBlock(), _createElementBlock("i", _hoisted_10, "person_off"))
            : _createCommentVNode("", true),
          _hoisted_11
        ]),
        _: 1
      })
    ]),
    _createElementVNode("nav", _hoisted_12, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createElementVNode("img", _hoisted_13, null, 512)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/games",
        "data-cy": "games-bottom"
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }),
      ($setup.isAdmin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "list"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ($setup.isAdmin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/admin"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, { to: "/user" }, {
        default: _withCtx(() => [
          ($setup.isLoggedIn)
            ? (_openBlock(), _createElementBlock("i", _hoisted_17, "person"))
            : _createCommentVNode("", true),
          (!$setup.isLoggedIn)
            ? (_openBlock(), _createElementBlock("i", _hoisted_18, "person_off"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("main", _hoisted_19, [
      _createVNode(_component_router_view),
      _createElementVNode("footer", _hoisted_20, _toDisplayString($setup.version), 1)
    ]),
    _createVNode(_component_an_toasts, {
      "close-icon": { class: 'extra', content: 'close' },
      "error-classes": "an-toast-default tickets-toast tickets-error top",
      "error-icon": { class: 'extra', content: 'priority_high' },
      "warn-classes": "an-toast-default tickets-toast tickets-warning top",
      "warn-icon": { class: 'extra', content: 'warning' },
      "info-classes": "an-toast-default tickets-toast tickets-info top",
      "info-icon": { class: 'extra', content: 'info' },
      "done-classes": "an-toast-default tickets-toast tickets-done bottom",
      "done-icon": { class: 'extra', content: 'done' }
    })
  ], 64))
}